import React from 'react';
import { Wind, Award, Shield, Palette, Zap } from 'lucide-react';

export const ValueProposition = () => {
  const values = [
    {
      icon: Palette,
      title: 'Timeless Design',
      description: 'Each piece is selected for its ability to elevate interiors with understated sophistication'
    },
    {
      icon: Wind,
      title: 'Whisper-Quiet Performance',
      description: 'Engineered for powerful, silent airflow that respects refined environments'
    },
    {
      icon: Zap,
      title: 'BLDC Motor Fans',
      description: 'Bernard Fan\'s BLDC motor fans consume 70% less power compared to conventional motor fans. With a power consumption of only 8-30 watts, it leads the way towards responsible and sustainable future.'
    },
    {
      icon: Shield,
      title: 'Built to Endure',
      description: 'Premium materials and engineering designed for long-term reliability'
    }
  ];

  return (
    <section className="py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center mb-20">
          {/* Logo on the left */}
          <div className="lg:col-span-4">
            <div className="flex justify-center lg:justify-start">
              <img
                src="/images/value-prop-logo.png"
                alt="Bernard Fan Co."
                className="w-full max-w-xs"
                style={{ mixBlendMode: 'multiply' }}
              />
            </div>
          </div>
          
          {/* Text content on the right */}
          <div className="lg:col-span-8 text-center lg:text-left">
            <h2 className="text-5xl md:text-6xl font-light tracking-tight text-stone-900 mb-6">
              Where Luxury Meets Practicality
            </h2>
            <p className="text-xl text-stone-600 font-light leading-relaxed">
              Meticulously designed to perfection, Bernard Fans offer a refined airflow experience and whisper-soft operation, turning your home into a serene retreat. No matter your aesthetic, there is a Bernard Fan to grace your ceiling and captivate you with its timeless sophistication and royal appeal.
            </p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {values.map((value, index) => {
            const bgColors = [
              'bg-gradient-to-br from-amber-500 to-orange-500',
              'bg-gradient-to-br from-cyan-500 to-blue-500',
              'bg-gradient-to-br from-emerald-500 to-green-600',
              'bg-gradient-to-br from-rose-500 to-pink-500'
            ];
            
            return (
              <div
                key={index}
                className="text-center space-y-6 group cursor-default"
              >
                <div className={`inline-flex items-center justify-center w-20 h-20 ${bgColors[index]} rounded-full shadow-lg group-hover:scale-110 transition-all duration-300`}>
                  <value.icon className="text-white" size={32} />
                </div>
                <h3 className="text-xl font-light tracking-wide text-stone-900">
                  {value.title}
                </h3>
                <p className="text-stone-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};